import css from './resultPane.module.scss';

import { Fragment, memo } from 'react';

import {
  getActionsByWord,
  TRepetitionAction,
  TRepetitionActionType,
} from 'core/helpers/repetition';
import Button from 'core/ui/Button';

import ButtonLabel from './ButtonLabel';
import { KkbLabel, KkbBind } from './ResultKkb';

type TProps = {
  goNext: () => void;
  disabled: boolean;
  word: TWord;
  exercise: TExercise;
  finishWord: (action: TRepetitionAction) => Promise<void>;
  className?: string;
};

const ResultAfterPane: React.FC<TProps> = ({
  goNext,
  disabled,
  word,
  finishWord,
  exercise,
  className = '',
}) => {
  const actions = getActionsByWord(word, exercise);

  const genHandler = (action: TRepetitionAction) => () => {
    if (action.type === TRepetitionActionType.skip) {
      goNext();
    } else {
      void finishWord(action);
    }
  };

  return (
    <div className={`${css.resultPane} ${className}`} data-after>
      {actions.map((action, idx) => (
        <Fragment key={idx}>
          <KkbBind
            action={action}
            idx={idx}
            disabled={disabled}
            handler={genHandler(action)}
          />
          <Button
            className={css.action}
            disabled={disabled}
            onClick={genHandler(action)}
            data-action-idx={idx}
          >
            <ButtonLabel action={action} word={word} exercise={exercise} />
            <KkbLabel action={action} idx={idx} />
          </Button>
        </Fragment>
      ))}
    </div>
  );
};

export default memo(ResultAfterPane);
